export const APPRAISER_EVENT_STAGE = {
  DRAFT: 10,
  ATL_ASSIGNED: 21,
  ATL_ASSIGNED_RETURNED: 22,
  ATL_ASSIGNED_SUBMITTED: 23,
  TEAM_REVIEW_OPEN_FOR_BID: 30,
  TEAM_ASSIGNED: 40,
  READY_TO_DELIVER: 50
};
